import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { useCohortFlag } from 'src/modules/hooks/useCohortFlag'
import { useHeroImageByWidth } from 'src/modules/hooks/useHeroImageByWidth'
import { WEB_MARKETING_HERO_IMAGE } from 'src/modules/reducers/cohorts/constants'
import { commonSubtitleText } from 'src/modules/utils/constants'
import styled from 'styled-components'

export default (props) => {
  const heroImage = useCohortFlag(WEB_MARKETING_HERO_IMAGE)
  const heroImageByWidth = useHeroImageByWidth(heroImage)
  return (
    <StyledContainer>
      <USTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        poster={heroImageByWidth}
        title="Watch your favorite shows, movies & sports"
        subtitle={commonSubtitleText.onAnyDevice}
        networkSet="entertainment"
        showRSN={true}
        isHeroDefault={!heroImageByWidth}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 740px;
  }
`
